import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { fetchCookie } from "./FetchCookie";
import SpinnerLoad from "./Spinner";

export default function RoleBasedProtectedRoute({ children, onRoleCheck }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(() => {
      const fetchUser = async () => {
        try {
          const userData = await fetchCookie();
          setUser(userData);
  
          if (userData?.user?.user_type) {
            onRoleCheck(userData.user.user_type);
          }
        } catch (error) {
          console.error("Error fetching user data:", error); 
        } finally {
          setLoading(false);
        }
      };
  
      fetchUser();
    }, [onRoleCheck]);
  
    if (loading) {
      return <SpinnerLoad />;
    }
  
    if (!user) {
      return <Navigate to="/login" replace />;
    }
  
    const role = user?.user?.user_type;
  
    // Pass role dynamically to children
    return typeof children === "function" ? children({ role }) : children;
  }
  
